import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

const flames = Array.from({ length: 12 }, (_, i) => ({
  id: i,
  left: `${5 + i * 8}%`,
  delay: i * 0.2,
  endY: -(200 + Math.random() * 200),
}))

export default function FlameParticles() {
  const containerRef = useRef(null)

  useGSAP(() => {
    const els = containerRef.current.querySelectorAll('.flame')
    els.forEach((el, i) => {
      gsap.to(el, {
        y: flames[i].endY,
        opacity: 0,
        duration: 2 + Math.random(),
        delay: flames[i].delay,
        repeat: -1,
        ease: 'power1.out',
        repeatDelay: Math.random() * 0.5,
      })
    })
  }, { scope: containerRef })

  return (
    <div ref={containerRef} className="absolute bottom-0 left-0 right-0 h-32 pointer-events-none overflow-hidden">
      {flames.map((f) => (
        <svg
          key={f.id}
          className="flame absolute bottom-0"
          style={{ left: f.left }}
          width="16"
          height="28"
          viewBox="0 0 16 28"
        >
          <defs>
            <linearGradient id={`fg${f.id}`} x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" stopColor="#FF6B00" />
              <stop offset="100%" stopColor="#FFB74D" stopOpacity="0.6" />
            </linearGradient>
          </defs>
          <path
            d="M8 0 C4 6, 0 10, 0 18 C0 23.5 3.6 28 8 28 C12.4 28 16 23.5 16 18 C16 10 12 6 8 0Z"
            fill={`url(#fg${f.id})`}
          />
        </svg>
      ))}
    </div>
  )
}
